// src/Components/LoginPage.jsx
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import axios from 'axios';
import Logo from '../ATH_Full_White.png';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import Swal from 'sweetalert2';

function LoginPage() {

  const { 
    setUser, 
    setView, 
    setCurrentCampus, 
    setCurrentProgram, 
    setCurrentGender, 
    setCurrentEvalCount,
    setCampusList, 
    setCoachObjectList,
    setNorms,
    CAMPUSES,
    updateAthleteList,
  } = useAppContext();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showLoginError, setShowLoginError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginData, setLoginData] = useState(null);


  useEffect(() => {
    const handleLoginSuccess = async (loginData) => {

      const loginDataArray = Object.keys(loginData).map((k) => loginData[k]);

      const currentUsernameIndex = loginDataArray.findIndex(
        (item) => item.username === username
      );

      if (currentUsernameIndex !== -1) 
      {
        const currentUserData = loginDataArray[currentUsernameIndex];
        
        setUser(currentUserData);

        if (currentUserData.role !== 'admin') 
        { 
          setCurrentCampus(currentUserData.campus);
          setCampusList([currentUserData.campus]); 
        }
        else
        {
          setCampusList(CAMPUSES)
          setCurrentCampus('All');
        }

        setCurrentProgram('All');
        setCurrentGender('All');
        setCurrentEvalCount('Any');

        setCoachObjectList(loginDataArray);

        // Load norms V2 (nested structure)
        try {
          const resV2 = await axios.post(`${process.env.REACT_APP_API_URL}api/flask`, {
            functionName: 'LoadTestNormsV2',
            inputArray: []
          });
          setNorms(resV2.data);
        } catch (error) {
          console.error('Error loading test norms V2:', error);
          Swal.fire('Error', 'Failed to load norms', 'error');
          return;
        }

        setView('capture');
        
        await updateAthleteList(currentUserData.role !== 'admin' ? currentUserData.campus : 'All', 'All', 'All', 'Any', 'Any', null);

      } else {
        throw new Error('User not found in login data');
      }
    };

    if (loginData) {
      handleLoginSuccess(loginData);
    }
  }, [loginData, username, setUser, setView, setCurrentCampus, setCampusList, setCoachObjectList, setNorms, updateAthleteList, CAMPUSES, setCurrentProgram, setCurrentGender, setCurrentEvalCount]);

  const login = async (username, password) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}api/flask`, {
        functionName: 'AuthenticateCoach',
        inputArray: [{ currentUsername: username, currentPassword: password }]
      });
      
      if (response.data.length === 0)
        setShowLoginError(true);  
      else 
      {
        setLoginData(response.data);
        setShowLoginError(false);
      }
    } catch (error) {
      Swal.fire('Server error!', 'Something has gone wrong with the login request. Please try again later or contact support for assistance.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(username, password);
  };

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <div className='loginPage'>
      <img className="loginLogo" src={Logo} alt="Logo" />
      <form onSubmit={handleSubmit} className='loginInputsContainer'>
        <div className='LoginInputDiv'>
          <label><FaUser /></label>
          <input
            className='LoginInputField'
            type='text'
            placeholder='username'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className='LoginInputDiv'>
          <label><FaLock /></label>
          <input
            className='LoginInputField'
            type={showPassword ? 'text' : 'password'}
            placeholder='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {showPassword ? 
            <FaEyeSlash className='ShowPasswordIcon' onClick={toggleShowPassword} /> :
            <FaEye className='ShowPasswordIcon' onClick={toggleShowPassword} />
          }
        </div>
        {showLoginError && 
          <p style={{ color: 'red', textAlign: 'center' }}>Incorrect username or password!</p>
        }
        <button 
          disabled={isLoading} 
          className='signInButton'
        >
          {isLoading ? "Logging In" : "Login"}
        </button>
      </form>
    </div>
  );
}

export default LoginPage;